import React, {Component} from 'react'

class TelaResposta extends Component {

    constructor(props) {
        super(props);
        this.state = {
            servidor: props.servidor,
            protocolo: props.protocolo
        }
    }

    render() {
        return(
            <div>
                <p>Agradecemos pela confiança!</p>
                <p>Número de protocolo gerado: {this.state.protocolo}</p>

                <br /><br />
            </div>
        )
    }
}

export default TelaResposta